import { render, staticRenderFns } from "./homework-correction.vue?vue&type=template&id=7247a7ff&scoped=true&"
import script from "./homework-correction.vue?vue&type=script&lang=js&"
export * from "./homework-correction.vue?vue&type=script&lang=js&"
import style0 from "./homework-correction.vue?vue&type=style&index=0&id=7247a7ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7247a7ff",
  null
  
)

export default component.exports